import React, { useState } from 'react';
import { BookMarked, GraduationCap, PlayCircle } from 'lucide-react';
import EnrolledCourses from '../../components/user/EnrolledCourses';
import MyLectures from '../MyLectures';
import { cardTheme } from '../../styles/cardTheme';

type Tab = 'courses' | 'lessons';

const PortalMyLearning: React.FC = () => {
  const [tab, setTab] = useState<Tab>('courses');

  return (
    <div className="pb-8 font-cairo" dir="rtl">
      <div className="px-4 pt-4 sm:px-6 sm:pt-6 lg:px-8">
        <div className="mb-5 text-center sm:mb-7">
          <span className={`mb-3 inline-flex ${cardTheme.badgeGold}`}>
            <BookMarked className="h-4 w-4" />
            مساحتك التعليمية
          </span>
          <h1 className={`mb-2 text-2xl font-bold sm:text-3xl ${cardTheme.title}`}>
            كورساتي وحصصي
          </h1>
          <p className={`mx-auto max-w-xl text-sm sm:text-base ${cardTheme.subtitle}`}>
            كورساتك وحصصك في مكان واحد — كمّل من حيث وقفت
          </p>
        </div>

        <div className="mx-auto mb-4 flex max-w-4xl gap-2 sm:mb-5">
          <button
            type="button"
            onClick={() => setTab('courses')}
            className={`inline-flex min-h-11 flex-1 items-center justify-center gap-2 rounded-xl px-3 text-sm font-bold transition-all sm:flex-none sm:px-5 ${
              tab === 'courses'
                ? 'bg-green-700 text-white shadow-md shadow-green-900/20'
                : 'border border-green-200 bg-white text-green-800 hover:bg-green-50'
            }`}
          >
            <GraduationCap className="h-4 w-4 shrink-0" />
            كورساتي
          </button>
          <button
            type="button"
            onClick={() => setTab('lessons')}
            className={`inline-flex min-h-11 flex-1 items-center justify-center gap-2 rounded-xl px-3 text-sm font-bold transition-all sm:flex-none sm:px-5 ${
              tab === 'lessons'
                ? 'bg-teal-700 text-white shadow-md shadow-teal-900/20'
                : 'border border-teal-200 bg-white text-teal-800 hover:bg-teal-50'
            }`}
          >
            <PlayCircle className="h-4 w-4 shrink-0" />
            حصصي
          </button>
        </div>
      </div>

      {tab === 'courses' ? <EnrolledCourses embedded /> : <MyLectures embedded />}
    </div>
  );
};

export default PortalMyLearning;
